import { useSelector } from 'react-redux';

import { selectFeatureFlags } from '@/model/selectors';

export function useHasCustomEmailSignature() {
  const featureFlags = useSelector(selectFeatureFlags);

  return !!featureFlags.customEmailSignature;
}
